import React from "react";
import { DataProvider } from "../cms/cmsProvider.js";

const RootProvider = ({ children }) => <DataProvider>{children}</DataProvider>;

export default RootProvider;
